import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import SubBanner from "../components/SubBanner"
import HeartSection from "../components/Health/HeartSection";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/health/substonebg.png";
import SubStone from "../components/Health/SubStone";
import SubFounder from "../components/Health/SubFounder";
import MedicalCareCarousel from "../components/Health/MedicalCareCarousel"
import founderPhoto from "../Assets/health/healthfounder.png";
import waveBg from "../Assets/background-wave.png";
import dotPattern from "../Assets/health/Ellipse 164.png";
import vcnrLogo from "../Assets/vcnr-logo-white.png";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/health/gallery/92-01.webp";
import Img2 from "../Assets/health/gallery/95-01.webp";
import Img3 from "../Assets/health/gallery/100-01.webp";
import Img4 from "../Assets/health/gallery/102-01.webp";
import Img5 from "../Assets/health/gallery/103-01.webp";
import Img6 from "../Assets/health/gallery/106-01.webp";
import Img7 from "../Assets/health/gallery/107-01.webp";
import Img8 from "../Assets/health/gallery/108-01.webp";
import TestimonialSlider from "../components/Health/TestimonialSlider";
import LeaderDivisionSection from "../components/Leadership/LeaderDivisionSection";
import VCNRContactHospitalBanner from "../components/Contact/VCNRContactHospitalBanner";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import QuickAccessRow from "../components/Career/QuickAccessRow";
import testimonialbg from "../Assets//rock-bg.png"
import SubJoinSection from "../components/Health/SubJoinSection";
import doctorImage from "../Assets/health/image 78.png";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import hospitalImg from "../Assets/health/Subservices-media-carousel-1.png";
import diagnosticsImg from "../Assets/health/Subservices-media-carousel-2.png";
import instituteImg from "../Assets/health/Subservices-media-carousel-3.png";
import pharmacyImg from "../Assets/health/Subservices-media-carousel-4.png";
import healthparksImg from "../Assets/health/Subservices-media-carousel-5.png";
import heartImage from '../Assets/health/heart.png';
import peopleImage from '../Assets/health/people.png';
import pulseLine from '../Assets/health/Layer_1.png';
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import { useNavigate } from "react-router-dom";
import HealthBuildWithUs from "../components/Health/HealthBuildWithUs";
import HealthBanner from "../components/Health/HealthBanner";
import founderPhoto1 from "../Assets/health/growth.png";


const Healthcare = () => {
  const navigate=useNavigate();
  const meta = seoMeta["/Healthcare"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const paragraphs = [
    `VCNR Healthcare was established with a clear purpose: to make quality healthcare affordable, accessible, and accountable to all, irrespective of geography or income.What started as a small step in Nelamangala has grown into a healthcare network dedicated to not just treating illnesses, but also preventing them. `,
    `We use our medical skills, smart systems, and knowledge of local communities to fix healthcare gaps in India. We improve facilities, sharing awareness, and make healthcare easy to access.`,
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
const healthcareCards = [
  { title: "Advanced Research in Biomedical Science", image: Img1 },
  { title: "Natural Remedies and Herbal Solutions", image: Img2 },
  { title: "Holistic Wellness and Nutritional Care", image: Img3 },
  { title: "Cutting-Edge Medical Equipment Testing", image: Img4 },
  { title: "Clinical Diagnostics and Lab Innovation", image: Img5 },
  { title: "Modern Healthcare Facilities at VCNR Health Park", image: Img6 },
  { title: "State-of-the-Art Hospital Infrastructure", image: Img7 },
  { title: "Residential Healthcare Campus for Professionals", image: Img8 }
];
const quickAccessCards = [
  {
    title: "Book Appointment",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Get Directions to VCNR Hospital",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Speak to Our Patient Helpline",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Download Hospital Brochure (PDF)",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Multi-specialty Hospital",
    description: "World-class treatment under one roof with departments including cardiology, pediatrics, general medicine, surgery, and more.",
    image: hospitalImg,
    link: "https://vcnrhealth.com/"
  },
  {
    title: "24x7 Diagnostics & Labs",
    description: "Advanced facilities with real-time results to enable timely and accurate interventions.",
    image: diagnosticsImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "VCNR Institute of Health Sciences",
    description: "Educating the next generation of healthcare professionals through training, certification, and research.",
    image: instituteImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "Integrated Pharmacy",
    description: "Convenient, affordable, and accessible medications for all patients.",
    image: pharmacyImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "Health Parks",
    description: "Community spaces for wellness programs, fitness initiatives, yoga and preventive health education.",
    image: healthparksImg,
        link: "https://vcnrhealth.com/"
  },
    {
    title: "Multi-specialty Hospital",
    description: "World-class treatment under one roof with departments including cardiology, pediatrics, general medicine, surgery, and more.",
    image: hospitalImg,
    link: "https://vcnrhealth.com/"
  },
  {
    title: "24x7 Diagnostics & Labs",
    description: "Advanced facilities with real-time results to enable timely and accurate interventions.",
    image: diagnosticsImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "VCNR Institute of Health Sciences",
    description: "Educating the next generation of healthcare professionals through training, certification, and research.",
    image: instituteImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "Integrated Pharmacy",
    description: "Convenient, affordable, and accessible medications for all patients.",
    image: pharmacyImg,
        link: "https://vcnrhealth.com/"
  },
  {
    title: "Health Parks",
    description: "Community spaces for wellness programs, fitness initiatives, yoga and preventive health education.",
    image: healthparksImg,
        link: "https://vcnrhealth.com/"
  },

];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
    <div className="section-wrapper">
    <div className="section-wrapper">
      <HealthBanner />
   {/* <HeartBanner
      heading="At our Medical Center,<br/>We Heal with Heart and a Purpose"
      subtext="At VCNR Healthcare, we believe every life deserves care that is both kind and groundbreaking. From rural clinics to specialized treatments, we are bringing healthcare closer to every Indian heart."
      buttonText="Explore Hospital"
        onButtonClick={() => window.location.href = "https://vcnrhealth.com/"}
        heartImageSrc={heartImage}
      peopleImageSrc={peopleImage}
      pulseLineSrc={pulseLine}
/> */}
</div>
<ParallaxSection><SubStory
      title="Healthcare Story"
      subtitle="Delivering Accessible, Quality Healthcare for Every Indian"
      paragraphs={paragraphs}
    /></ParallaxSection>
    <div className="section-wrapper sec-bg"><ParallaxSection><SubStone
  imageSrc={bgImage}
  heading={<>Our Goal is not Just to<br />
 Treat Symptoms but to Heal Stories.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/aboutVCNR"}
/></ParallaxSection>
<ParallaxSection>
  <SubFounder
    dotPattern={dotPattern}
    founderImage={founderPhoto}
    logo={vcnrLogo}
    heading="What We Do"
    name="Stories of Strength and Healing"
    role=""
    messages={[
      "100-bed Multi-Specialty Hospital in Nelamangala, with surgical, diagnostic, and emergency care services",
      "Primary and Preventive Health Programs in semi-urban and rural areas",
      "Mobile Medical Services and outreach health camps for underserved communities",
      "Health Plans for individuals and families, with a focus on early detection and lifestyle management",
      "Healthcare Education through our in-house Nursing College, which serves as a feeder for trained, compassionate staff"
    ]}
    buttonText="Meet Our Doctors"
  />
</ParallaxSection>
        <ParallaxSection><SubJoinSection
  image={doctorImage}
  title="Our Model of Impact"
  subtitle=""
  description={<>Complete Care, Start to Finish: From your first consultation to follow-up after treatment, we’re with you every step of the way.<br />
  Skilled Hands, Caring Hearts: Our in-house Nursing College trains a steady team of skilled, service-minded healthcare professionals.<br />
  Health in the Community: We run awareness programs, help manage chronic illnesses, and focus on maternal and child health.<br />
  Digital-First Healthcare: We use digital health records and remote access tools to make healthcare faster, smarter, and easier to reach.</>}
  secondaryText=""
    buttonLink="/Career"           // ← primary button link
  secondButtonLink="/Contact"
/></ParallaxSection></div>
<SubFounder
    dotPattern={dotPattern}
    founderImage={founderPhoto1}
    logo={vcnrLogo}
    heading="Our Growth Path"
    name=""
    role=""
    messages={[
      "Reaching More People: We’re planning a network of hospitals across major southern states to bring quality care closer to communities.",
      "Expanding What We Offer: From advanced diagnostics to wellness parks and rehabilitation centres, we’re expanding our services.",
      "Smarter with Technology: Using telemedicine, AI-powered triage, and modern hospital management systems to make care faster and more effective.",
      "Stronger Together: Partnering with medical experts, tech innovators, and rural health networks to create better delivery models.",
      "At VCNR Healthcare, we’re creating a healthcare ecosystem where care isn’t just a service, but a promise, built on empathy, strengthened by infrastructure, and focused on real results."
    ]}
    buttonText="Meet Our Doctors"
  />
<ParallaxSection><Subservicesmediacarousel
      title="A Wholehearted Circle Of Medical Care Provider"
      services={servicesData}
    /></ParallaxSection>


    <ParallaxSection><OutreachSection
          title="Our Healthcare Outreach"
          subheading="Extending Care Beyond Walls Through Hospitals, Health Parks, and a Seamless Hospital Integrated System."
          description={[
            "At VCNR, we believe care doesn’t stop at the hospital doors. Through our expanding network of hospitals, new medical centers, health parks, and accessible health plans, our hospital integrated system ensures quality care reaches every corner of the community.",
            "But our work goes beyond buildings. We take healthcare to people’s doorsteps by running rural health camps, school-based screenings, elderly wellness programs, and even performing life-saving surgeries for those who can’t afford them. Wherever someone lives, VCNR is committed to being their partner in health."
          ]}
          cardsData={healthcareCards}
          buttonText="Become a Volunteer"
          onButtonClick={() => navigate("/Contact")}
        /></ParallaxSection>
        <ParallaxSection><SubStory
      title={
    <>
      Patient Stories of Strength and Healing
    </>
  }
      paragraphs={paragraphs1}
    /></ParallaxSection>
    {/* <LeaderDivisionSection /> */}
    
        <div className="section-wrapper sec-bg"><ParallaxSection><TestimonialSlider
        testimonials={aboutTestimonials}
        backgroundImage={testimonialbg}
      /></ParallaxSection></div>

        <ParallaxSection><QuickAccessRow cards={quickAccessCards} /></ParallaxSection>
        <div><br /><br /><br /></div>
        <div className="section-wrapper"><ParallaxSection><HealthBuildWithUs /></ParallaxSection></div>
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection>
          
          

    </div>
</>
  );
};

export default Healthcare;
